<div [ngClass]="inputType.Text !== params?.colDef?.inputType ? 'textWrapper' : 'text-input'">
  <div class="title">{{ title }}</div>
  <div *ngIf="readonly" class="textArea">{{ currentValue }}</div>
  <ng-container *ngIf="inputType.Text == params?.colDef?.inputType; else textAreaTemplate">
    <mat-form-field appearance="outline" class="text-input-field">
      <input
        *ngIf="!readonly"
        autocomplete="off"
        class="main-input"
        #input
        matInput
        [ngModel]="currentValue"
        [maxLength]="maxAllowedChars"
        (ngModelChange)="onInputChange(input.value)"
      />
    </mat-form-field>
  </ng-container>

  <ng-template #textAreaTemplate>
    <textarea
      *ngIf="!readonly"
      autocomplete="no-autofill"
      #textValue
      class="textArea"
      [(ngModel)]="currentValue"
      (keydown)="handleKeydown($event)"
      (blur)="onBlur()"
    ></textarea>
    <div (click)="close($event)" class="close-text-popup">{{ doneText }}</div>
  </ng-template>
</div>
